/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const KeyValueMultiLineFieldPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The label for the field
   */
  label: PropTypes.string.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The value for the field
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};

export default KeyValueMultiLineFieldPropTypes;
